/*
 * @Author: qlc qianlc@lianchuang.com
 * @Date: 2023-02-28 10:15:40
 * @LastEditors: qlc qianlc@lianchuang.com
 * @LastEditTime: 2023-03-13 13:32:16
 * @FilePath: /syjs-manage-web/src/utils/commonUtil.js
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
export default {
  //获取特定表格样式
  tableRowClassName({ row }) {
    if (row.unitName === '合计' || row.channelName === '合计') {
      return 'warm-row'
    }
  },
  //表格合并同类项
  getSpanArr(data, keys = [], isAll = false, haveSum = false) {
    if (data == null) {
      return []
    }
    var spanArr = []
    var _pos = 0
    for (var i = 0; i < data.length; i++) {
      if (i === 0) {
        spanArr.push(1)
        _pos = 0
      } else {
        if (isAll == false) {
          // 判断当前元素与上一个元素是否相同
          let num = 0
          keys.forEach(item => {
            if (data[i][item] === data[i - 1][item]) {
              num += 1
            }
          })
          if (num == keys.length) {
            spanArr[_pos] += 1
            spanArr.push(0)
          } else {
            spanArr.push(1)
            _pos = i
          }
        } else {
          if (i < data.length - (haveSum ? 1 : 0)) {
            spanArr[_pos] += 1
            spanArr.push(0)
          } else {
            spanArr.push(1)
            _pos = i
          }
        }
      }
    }
    return spanArr
  },
  downloadFileDefault(data, name) {
    const a = document.createElement('a')
    a.setAttribute('href', data)
    a.setAttribute('download', name)
    a.setAttribute('target', '_blank')
    const clickEvent = document.createEvent('MouseEvents')
    clickEvent.initEvent('click', true, true)
    a.dispatchEvent(clickEvent)
  },
  //文件下载
  downloadFile(data, name) {
    const link = document.createElement('a')
    let blob = new Blob([data], {
      type: 'application/vnd.ms-excel;charset=utf-8'
    })
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    let num = ''
    for (let i = 0; i < 10; i++) {
      num += Math.ceil(Math.random() * 10)
    }
    link.setAttribute('download', name + num + '.xls')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  //文件下载
  downloadFileZip(data, name) {
    const link = document.createElement('a')
    let blob = new Blob([data], {
      type: 'application/vnd.ms-excel;charset=utf-8'
    })
    link.style.display = 'none'
    link.href = URL.createObjectURL(blob)
    let num = ''
    for (let i = 0; i < 10; i++) {
      num += Math.ceil(Math.random() * 10)
    }
    link.setAttribute('download', name + num + '.zip')
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  },
  parseTime(time, cFormat) {
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    cFormat = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let ret
    var weekLong = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五']
    var weekShort = ['日', '一', '二', '三', '四', '五']
    const opt = {
      'y+': date.getFullYear().toString(), // 年
      'M+': (date.getMonth() + 1).toString(), // 月
      'd+': date.getDate().toString(), // 日
      'h+': (date.getHours() % 12 === 0 ? 12 : date.getHours() % 12).toString(), // 时,12
      'H+': date.getHours().toString(), // 时,24
      'm+': date.getMinutes().toString(), // 分
      's+': date.getSeconds().toString(), // 秒
      'a+': date.getHours() < 12 ? '上午' : '下午', // 上午/下午
      'A+': date.getHours() < 12 ? 'AM' : 'PM', // AM/PM
      'W+': date.getDay(), // 星期
      'w+': date.getDay() // 星期
    }
    for (let k in opt) {
      ret = new RegExp('(' + k + ')').exec(cFormat)
      if (ret && ret[1] != 'w' && ret[1] != 'W') {
        cFormat = cFormat.replace(
          ret[1],
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, '0')
        )
      } else if (ret && ret[1] === 'W') {
        let val =
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, 0)
        cFormat = cFormat.replace(ret[1], weekLong[val])
      } else if (ret && ret[1] === 'w') {
        let val =
          ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, 0)
        cFormat = cFormat.replace(ret[1], weekShort[val])
      }
    }
    return cFormat
  },
  //日期格式化
  traveDate(data, symbol = '-') {
    var yearRatio = data.getFullYear(data)
    var mouthRatio =
      data.getMonth() + 1 >= 10
        ? data.getMonth() + 1
        : '0' + (data.getMonth() + 1)
    var dayRatio = data.getDate() >= 10 ? data.getDate() : '0' + data.getDate()
    var YYMMDD = yearRatio + symbol + mouthRatio + symbol + dayRatio
    return YYMMDD
  },
  yuanToFen(val) {
    if (val) {
      let string = val.toString()
      let array = string.split('.')
      if (array.length > 1 && array[1].length == 1) {
        var temp = array[1]
        array[1] = temp + '0'
      } else if (array.length > 1 && array[1].length > 2) {
        var temp = array[1].substr(0, 2)
        array[1] = temp
      } else if (array.length == 1) {
        array[1] = '00'
      }
      let string2 = array.join('')
      return parseInt(string2)
    } else {
      return 0
    }
  },
  //file文件转base64
  getBase64(file) {
    return new Promise((resolve, reject) => {
      if (file instanceof File) {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
      } else {
        reject('请选择文件')
      }
    })
  }
}
